import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

/**
 * Instala um interceptor global do axios para tratar HTTP 423 (Locked),
 * emitido pelo backend quando um profissional com pendências críticas de
 * governança tenta escrever em agendamentos após 20/08/2026.
 *
 * Comportamento:
 *  - Exibe um toast explicativo (mensagem vinda do backend).
 *  - Redireciona para /dashboard/minhas-pendencias.
 *  - Rejeita a promise para não engolir o erro (chamador pode limpar loading).
 *
 * Registrado uma única vez em <App/> dentro do Router (precisa de useNavigate).
 */
export default function AxiosGovernanceInterceptor() {
  const navigate = useNavigate();

  useEffect(() => {
    const id = axios.interceptors.response.use(
      (r) => r,
      (error) => {
        if (error?.response?.status === 423) {
          const detail = error.response.data?.detail || {};
          const msg = detail.mensagem || 'Sua agenda está bloqueada por pendências. Regularize para continuar.';
          const redirect = detail.redirect_to;
          try {
            toast.error(msg, { duration: 8000, id: 'governanca-423' });
          } catch { /* noop */ }
          // Só redireciona se o backend indicar um destino (caso do profissional).
          // Para Recepção/Admin (Sub-etapa 6.4) `redirect_to` vem null — apenas o toast.
          if (redirect) {
            try {
              if (window.location.pathname !== redirect) {
                navigate(redirect, { replace: false });
              }
            } catch { /* noop */ }
          }
        }
        return Promise.reject(error);
      }
    );
    return () => {
      axios.interceptors.response.eject(id);
    };
  }, [navigate]);

  return null;
}
